import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-849730e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = {
  key: 0,
  class: "header-title"
}
const _hoisted_3 = {
  key: 1,
  class: "header-description"
}
const _hoisted_4 = { class: "header-right" }
const _hoisted_5 = { class: "view-more-text" }
const _hoisted_6 = {
  key: 0,
  class: "el-icon-arrow-right view-more-chevron",
  "aria-hidden": "true"
}

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'card',
  props: {
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  bodyStyle: {
    type: Object,
    default: () => ({})
  },
  cardHeaderStyle: {
    type: Object,
    default: () => ({})
  },
  border: {
    type: Boolean,
    default: true
  },
  size: {
    type: String as PropType<'first' | 'second' | 'third' | ''>,
    default: 'first'
  },
  backgroundColor: {
    type: String,
    default: ''
  },
  onViewMore: {
    type: Function as PropType<() => void>,
    default: undefined
  },
  viewMoreText: {
    type: String,
    default: ''
  },
  viewMoreButtonType: {
    type: String as PropType<'text' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | ''>,
    default: 'text'
  },
  viewMoreButtonSize: {
    type: String as PropType<'large' | 'default' | 'small'>,
    default: 'small'
  },
  /** 无订阅权益时禁用「查看全部」 */
  viewMoreDisabled: {
    type: Boolean,
    default: false
  },
  /** 挂载时播放全站统一入场动效（cm-ui-rise-in），滚动加载/高频切换场景可关闭 */
  rise: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const {t} = useI18n()
const props = __props

const cardStyle = computed(() => {
  const style: Record<string, string> = {}
  if (props.backgroundColor) {
    style.backgroundColor = props.backgroundColor
  }
  return style
})


function handleViewMore () {
  if (props.viewMoreDisabled || !props.onViewMore) return
  props.onViewMore()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-wrap", {
      'is-border': __props.border,
      'size-first': __props.size === 'first',
      'size-second': __props.size === 'second',
      'size-third': __props.size === 'third'
    }]),
    style: _normalizeStyle(cardStyle.value)
  }, [
    (__props.title || _ctx.$slots.titleAfter || _ctx.$slots.headerRight || _ctx.$slots.header || __props.description || __props.onViewMore)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "card-header",
          style: _normalizeStyle(__props.cardHeaderStyle)
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.$slots.header)
              ? _renderSlot(_ctx.$slots, "header", { key: 0 })
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (__props.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "titleAfter"),
                  (__props.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.description), 1))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "headerRight"),
            (__props.onViewMore)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: __props.viewMoreButtonType,
                  size: __props.viewMoreButtonSize,
                  text: __props.viewMoreButtonType === 'text',
                  disabled: __props.viewMoreDisabled,
                  class: "view-more-button",
                  onClick: handleViewMore
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.viewMoreText || _unref(t)('commonPage.viewAll')), 1),
                    (__props.viewMoreButtonType === 'text')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["type", "size", "text", "disabled"]))
              : _createCommentVNode("", true)
          ])
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "card-body",
      style: _normalizeStyle(__props.bodyStyle)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ], 6))
}
}

})